import { render } from "./TradeInFormView.vue?vue&type=template&id=cdbc00bc&scoped=true"
import script from "./TradeInFormView.vue?vue&type=script&lang=js"
export * from "./TradeInFormView.vue?vue&type=script&lang=js"

import "./TradeInFormView.vue?vue&type=style&index=0&id=cdbc00bc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cdbc00bc"]])

export default __exports__